var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"lv-intercom-frame"},[_c('iframe',{ref:"intercomFrame",attrs:{"frameborder":"0","allowtransparency":"true","src":"javascript:void(0);"}})])}
var staticRenderFns = []

export { render, staticRenderFns }